import forEachElement from './forEachElement';

/**
 * Adds one more classes to the given selector or elements
 * @param elements The string selector or element(s) you wish to add classes to
 * @param classNames One or more classes you wish to add to each element
 */
export default function addClass(elements, ...classNames) {
  forEachElement(elements, el =>
    classNames.forEach(className =>
      el.classList.add(className)
    )
  );
}



// WEBPACK FOOTER //
// ./client/app/scripts/principles/selectors/addClass.js